<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isGarbageTypeDetailLoading">
      <div class="tab-info-card">
        <div class="user-detail">
          <div class="tab-info-title tab-info-title-flex">
            <span>基本资料</span>
            <el-button type="primary" size="mini" @click="editGarbage">编辑</el-button>
          </div>
          <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" />
        </div>
      </div>
      <!-- tab内容 -->
      <div class="tab-info-card tab-info-padding">
        <div>
          <div class="tab-info-title">关联物品</div>
        </div>
        <wt-form-table :form.sync="firstForm" @on-button-action="onButtonAction" >
          <wt-form-table-list ref="garbageTableRef" slot="wtFormTableList" :form.sync="firstForm" @on-button-action="onButtonAction">
            <template slot="coverPath" slot-scope="data">
              <img class="table-img" v-if="data.row.coverPath && data.row.coverPath.length > 0" :src="imgUrl + data.row.coverPath">
            </template>
          </wt-form-table-list>
        </wt-form-table>
      </div>
    </div>
    <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="30%"
      :modal="false"
      append-to-body
      class="min-dialog-wrap"
      :show-close="false"
      :before-close="handleClose">
      <div class="dialog-input-card">
        <el-form v-if="dialogVisible" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
          <el-form-item label="垃圾名称:" prop="name" required>
            <el-input type="text" v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item v-if="dialogVisible" label="垃圾图片:" prop="coverPathList" required>
            <wt-upload class="wt-image-upload" :value.sync="ruleForm.coverPathList" :multiple="true" :limit="editObj.limit" :file-size="editObj.fileSize" markText="上传图片尺寸140x140px"/>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
    <wt-detail-page  :visible.sync="editObj.visible" :component-name="editComponentName" component-type="edit" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import request from '@/utils/request'
export default {
  name: 'GarbageKnowledgeView',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      formCode: 'MODULES_USERMESSAGE',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/userMessage/userMessageUpdate',
      formAddUrl: '/modules/userMessage/userMessageAdd',
      detailFormButtons: {
        title: '',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '',
        className: 'wt-section-long-content',
        elements: [
          { name: '垃圾名称', key: 'name', type: 'text', disabled: true, className: 'wt-col-6' },
          { name: '垃圾图片', key: 'coverPathList', type: 'image', disabled: true },
          { name: '垃圾介绍', key: 'content', type: 'editor', disabled: true }]
      },
      firstForm: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULES_USERMESSAGE',
        formComponent: {
          list: { type: 'default', value: '/modules/garbage/garbageList' },
          delete: { type: 'default', value: '/modules/garbage/garbageDelete' }
        },
        formInputsData: [{ name: '物品名称', key: 'name', value: '', type: 'customAll' },
          { name: '类型', key: 'typeId', value: '', type: 'customAll' }],
        formButtonsData: [{ name: '新增', key: 'ADDGOODS', action: 'ADDGOODS', className: 'primary', hidden: false },
          { name: '删除', key: 'DELETE', action: 'DELETE_LIST', hidden: false }],
        formTableData: [
          { name: '垃圾图片', key: 'coverPath', type: 'custom' },
          { name: '垃圾名称', key: 'name', type: 'text' },
          { name: '创建时间', key: 'createTime', type: 'text', sortable: 'custom' },
          { name: '创建人', key: 'createUserName', type: 'text' }],
        formTableButtonsData: [{ name: '编辑', key: 'EDITGOODS', action: 'EDITGOODS', className: 'primary', hidden: false },
          { name: '删除', key: 'DELETE', action: 'DELETE', className: 'danger', hidden: false }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true, searchButtonHidden: true }
      },
      dialogVisible: false,
      ruleForm: {
        name: '',
        typeId: 0,
        coverPath: '',
        coverPathList: []
      },
      rules: {
        name: [
          { required: true, message: '请输入垃圾名称', trigger: 'blur' },
          { min: 1, max: 20, message: '垃圾名称长度不能超过20', trigger: 'blur' }
        ],
        coverPathList: [
          { required: true, message: '请上传垃圾图片', trigger: 'blur' }
        ]
      },
      editComponentName: 'GarbageKnowledgeEdit',
      editObj: {
        visible: false,
        limit: 1
      }
    }
  },
  created() {
    this.$store.dispatch('appendBreadcrumb', { meta: { title: '垃圾详情' }})
    this.firstForm.formInputsData[1].value = this.detailFormData.id
    this.ruleForm.typeId = this.detailFormData.id
    this.detailFormData.coverPathList = [{ fileUrl: this.detailFormData.coverPath }]
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$store.dispatch('removeBreadcrumb')
        this.$emit('on-dialog-action', 'close')
        this.$emit('on-dialog-action', 'refresh')
      }
    },
    editGarbage() {
      this.editObj.visible = true
    },
    onButtonAction(data) {
      if (data && data.item) {
        if (data.item.action === 'ADDGOODS') {
          this.ruleForm = {
            name: '',
            typeId: this.detailFormData.id,
            coverPath: '',
            coverPathList: []
          }
          this.dialogVisible = true
        }
        if (data.item.action === 'EDITGOODS') {
          this.ruleForm = JSON.parse(JSON.stringify(data.row))
          this.ruleForm.typeId = this.detailFormData.id
          this.ruleForm.coverPathList = [{ fileUrl: data.row.coverPath }]
          this.dialogVisible = true
        }
      }
    },
    handleClose() {
      this.dialogVisible = false
    },
    /*  ------------------------- 网络请求  -------------------------  */
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    },
    submitForm(formName) {
      const that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const sendData = JSON.parse(JSON.stringify(this.ruleForm))
          if (this.ruleForm.coverPathList && this.ruleForm.coverPathList.length > 0) {
            sendData.coverPath = this.ruleForm.coverPathList[0].fileUrl
          }
          if (sendData.createTime) {
            request({
              url: '/modules/garbage/garbageUpdate',
              method: 'post',
              data: sendData
            }).then(res => {
              if (res.code === '0') {
                that.$message({ message: '保存成功', type: 'success' })
                this.$refs.garbageTableRef.requestList()
                that.handleClose()
              }
            })
          } else {
            request({
              url: '/modules/garbage/garbageAdd',
              method: 'post',
              data: sendData
            }).then(res => {
              if (res.code === '0') {
                that.$message({ message: '保存成功', type: 'success' })
                this.$refs.garbageTableRef.requestList()
                that.handleClose()
              }
            })
          }
        } else { return false }
      })
    }
  },
  computed: {
    ...mapState({
      isGarbageTypeDetailLoading: state => state.garbageType.isGarbageTypeDetailLoading,
      detailFormData: state => state.garbageType.garbageTypeDetailData
    })
  }
}
</script>

<style lang="scss" scoped>
.dialog-input-card {
  padding: 20px;
}
.tab-info-title {
  padding: 20px;
  border-bottom: 1px solid rgba(228, 228, 228, 1);
  font-size: 16px;
  font-weight: 600;
  color: #444;
}
.tab-info-title-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tab-info-card {
  margin-top: 20px;
  background: #fff;

  .tab-base {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .tab-base-item {
      display: flex;
      align-items: center;
      width: 400px;
      margin-bottom: 20px;
    }
    .tab-base-label {
      width: 100px;
      text-align: right;
      color: #989898;
    }
    .tab-base-value {
      color: #666666;
    }
  }
  .tab-info-content {
    padding: 20px;
  }
}
.tab-info-padding {
  padding: 20px;
}
</style>
